import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

// Task Results API (existing functionality)
export const FETCH_STUDENT_TASK_RESULTS_REQUEST = 'FETCH_STUDENT_TASK_RESULTS_REQUEST';
export const FETCH_STUDENT_TASK_RESULTS_SUCCESS = 'FETCH_STUDENT_TASK_RESULTS_SUCCESS';
export const FETCH_STUDENT_TASK_RESULTS_FAILURE = 'FETCH_STUDENT_TASK_RESULTS_FAILURE';

// Task List API (new functionality)
export const FETCH_STUDENT_TASK_LIST_REQUEST = 'FETCH_STUDENT_TASK_LIST_REQUEST';
export const FETCH_STUDENT_TASK_LIST_SUCCESS = 'FETCH_STUDENT_TASK_LIST_SUCCESS';
export const FETCH_STUDENT_TASK_LIST_FAILURE = 'FETCH_STUDENT_TASK_LIST_FAILURE';

const buildStudentTaskResultsUrl = (groupId) => buildUrl(`/groups/${groupId}/student-task-results`);
const buildStudentTaskListUrl = (sessionId, language) =>
  buildUrl(`/sessions/${sessionId}/student-tasks${language ? `?language=${language}` : ''}`);

// Fetch student task results (completion status)
export function fetchStudentTaskResultsIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentTaskResultsUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchStudentTaskResults(groupId));
  };
}

export function fetchStudentTaskResults(groupId) {
  return (dispatch) => {
    const url = buildStudentTaskResultsUrl(groupId);
    const method = 'GET';

    return dispatch(fetchStudentTaskResultsRequest()).payload
      .then((response) => dispatch(fetchStudentTaskResultsSuccess(response)))
      // the endpoint is not available in every environment yet, degrade to empty results
      .catch(() => dispatch(fetchStudentTaskResultsSuccess([])));

    function fetchStudentTaskResultsRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchStudentTaskResultsSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchStudentTaskResultsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_RESULTS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}

// Fetch student task list (task definitions)
export function fetchStudentTaskListIfNeeded(sessionId, language) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentTaskListUrl(sessionId, language) })) {
      return false;
    }

    return dispatch(fetchStudentTaskList(sessionId, language));
  };
}

export function fetchStudentTaskList(sessionId, language) {
  return (dispatch) => {
    const url = buildStudentTaskListUrl(sessionId, language);
    const method = 'GET';

    return dispatch(fetchStudentTaskListRequest()).payload
      .then((response) => dispatch(fetchStudentTaskListSuccess(response, sessionId)))
      .catch((error) => dispatch(fetchStudentTaskListFailure(error)));

    function fetchStudentTaskListRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchStudentTaskListSuccess(payload, sid) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_SUCCESS,
        payload,
        url,
        method,
        sessionId: sid,
      });
    }

    function fetchStudentTaskListFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_TASK_LIST_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}

// Keep old function names for backward compatibility
export const fetchStudentTasksIfNeeded = fetchStudentTaskResultsIfNeeded;
export const fetchStudentTasks = fetchStudentTaskResults;



// WEBPACK FOOTER //
// ./data/StudentTasks/actions.js